module.exports = __webpack_public_path__ + "media/Text_headline_+_9x16.7e6d6a5c.mp4";